<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editExternalOrganizations') }}</h1>
      <div class="form-container">
        <ExternalOrganizationForm :data="relations.instance" @save="save"></ExternalOrganizationForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import ExternalOrganizationForm from "@/components/ExternalOrganizationForm"

  export default {
    components: {
      ExternalOrganizationForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'external_organizations', payload}).then(() =>
          this.$router.push({ name: 'externalOrganizations'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'external_organizations', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'externalOrganizations', path: 'externalOrganizations'},
          {name: 'editExternalOrganizations'}
        ]
      }
    }
  }
</script>